// @flow
import * as React from "react";
import cx from "classnames";

import styles from "./AddField.scss";
import sharedStyles from "../shared/Shared.scss";

type AddFieldProps = {
  handleClick: () => void,
  text: () => React.Node
};

const AddField = ({ handleClick, text }: AddFieldProps) => (
  <button type="button" className={cx(sharedStyles.button, styles.addButton)} onClick={handleClick}>
    <i className="icon-plus-circled" />
    &nbsp;
    {text()}
  </button>
);

export default AddField;
